import React from 'react';

import { Breadcrumbs } from '../components/Detail/Breadcrumbs';

const BreadcrumbsCont = () => <Breadcrumbs />;

export { BreadcrumbsCont as Breadcrumbs };
